module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between mb-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("\n            Zeige \n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateResettingPage()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "200"
    }
  }, [_vm._v("200")])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-5 flex-grow-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control w-100",
    attrs: {
      "type": "text",
      "placeholder": "Suche..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }, function($event) {
        return _vm.updateResettingPage()
      }]
    }
  })])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-responsive table-striped"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.columns), function(column) {
    return (column.sortable) ? _c('th', {
      key: column.name,
      class: _vm.sortColumn === column.name ? (_vm.sortDirection === 'desc' ? 'sorting_desc' + ' ' + column.class : 'sorting_asc' + ' ' + column.class) : 'sorting' + ' ' + column.class,
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "scope": "col"
      },
      on: {
        "click": function($event) {
          return _vm.sort(column)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(column.label) + "\n                ")]) : _c('th', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v("\n                    " + _vm._s(column.label) + "\n                ")])
  }), _vm._v(" "), (_vm.$scopedSlots.extras) ? _c('th', [_vm._v("\n                    " + _vm._s(_vm.extrasColumnName || '') + "\n                ")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', [(_vm.error) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.columns.length
    }
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.trans('messages.error')) + ": " + _vm._s(_vm.error))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rows), function(row) {
    return _c('tr', [_vm._l((row.cells), function(cell) {
      return _c('td', [(cell.html != null) ? _c('div', {
        domProps: {
          "innerHTML": _vm._s(cell.html)
        }
      }) : _c('div', [_vm._v(_vm._s(cell.text))])])
    }), _vm._v(" "), (_vm.$scopedSlots.extras) ? _c('td', [_vm._t("extras", null, {
      "row": row
    })], 2) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.rows.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.columns.length
    }
  }, [_vm._v(_vm._s(_vm.trans('messages.no_data')))])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.pagination.total) ? _c('span', [_vm._v("\n                        Einträge " + _vm._s(_vm.pagination.from) + " - " + _vm._s(_vm.pagination.to) + " von " + _vm._s(_vm.pagination.total) + "\n                        (Seite " + _vm._s(_vm.pagination.current_page) + " von " + _vm._s(_vm.pagination.last_page) + ")\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [(_vm.pagination.current_page > 1) ? _c('a', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]) : _c('a', {
    staticClass: "btn btn-default btn-sm disabled"
  }, [_vm._v("\n                             \n                        ")]), _vm._v(" "), (_vm.pagination.current_page + 1 <= _vm.pagination.last_page) ? _c('a', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _c('a', {
    staticClass: "btn btn-default btn-sm disabled"
  }, [_vm._v("\n                             \n                        ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cbaaa0b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ServerSideDataTable.vue
// module id = 124
// module chunks = 0